export default "__VITE_ASSET__Bfxv3JFh__"